import * as yup from 'yup';
import { translate } from '../../../shared/i18n';

export const schemaHolidayCreate = yup.object().shape({
  description: yup
    .string()
    .required(translate('holidaysModal.validation.descriptionRequired')),
  day: yup.string().required(translate('holidaysModal.validation.dayRequired')),
  month: yup
    .string()
    .required(translate('holidaysModal.validation.monthRequired')),
});

export const schemaHolidayEdit = yup.object().shape({
  description: yup
    .string()
    .required(translate('holidaysModal.validation.descriptionRequired')),
  day: yup.string().required(translate('holidaysModal.validation.dayRequired')),
  month: yup
    .string()
    .required(translate('holidaysModal.validation.monthRequired')),
  status: yup
    .boolean()
    .required(translate('holidaysModal.validation.statusRequired')),
});
